"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("react-hook-schema/core");
const classnames_1 = __importDefault(require("classnames"));
const fieldWrapper_1 = require("./common/fieldWrapper");
const displayWrapper_1 = require("./common/displayWrapper");
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const slider_1 = require("./common/slider");
const NumberSchemaComponent = (props) => {
    const { schema } = props;
    const { uiType, minValue, maxValue } = schema;
    const { registerProps, value, fieldState } = (0, core_1.useField)(props, [
        core_1.requiredValidator,
    ]);
    const options = (0, react_1.useMemo)(() => {
        const options = [];
        if (minValue === undefined || maxValue === undefined)
            return options;
        for (let i = minValue; i <= maxValue; i++) {
            options.push({
                title: i.toString(),
                value: i,
            });
        }
        return options;
    }, [minValue, maxValue]);
    const sliderValue = (0, react_1.useMemo)(() => {
        const index = options.findIndex((option) => option.value === value);
        return index === -1 ? undefined : index;
    }, [options, value]);
    const sliderOnChange = (0, react_1.useCallback)((index) => {
        const option = index != null ? options[index] : undefined;
        registerProps.onChange(option === null || option === void 0 ? void 0 : option.value);
    }, [registerProps.onChange, options]);
    if (uiType === "slider" && (minValue === undefined || maxValue === undefined))
        return react_1.default.createElement("div", null, "Set minValue and maxValue when uiType is slider.");
    return (react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: fieldState }, uiType === "slider" ? (react_1.default.createElement(slider_1.Slider, { options: options, onChange: sliderOnChange, value: sliderValue, hasError: fieldState.invalid })) : (react_1.default.createElement(Form_1.default.Control, Object.assign({ type: "number", pattern: "\\d*", min: minValue, max: maxValue, className: (0, classnames_1.default)({
            "has-error": fieldState.invalid,
        }), value: typeof value === "number" ? value : "" }, registerProps, { onChange: (e) => {
            registerProps.onChange(parseInt(e.target.value));
        } })))));
};
NumberSchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("NumberDisplayComponent");
exports.default = NumberSchemaComponent;
